import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Lunch(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Lunch", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.7292 13.6465c-1.6566 0-3.2442.3452-4.7628.9664 0-.069.069-.1381.069-.1381.069-.7592.069-1.5185 0-2.2778 1.2425.4832 2.623.6902 3.9345.7593.9664 0 2.0018-.2071 2.8991-.6213 3.2443-1.7256 4.1416-5.59113 4.2107-5.79821.069-.48319-.1381-.96638-.5523-1.17346-.207-.13805-5.0389-2.48495-8.2831-.69026-1.3806.75929-2.485 1.93274-3.2443 3.31327-.6212-1.38053-1.5876-2.62301-2.8991-3.45133-.4832-.34513-1.1044-.20708-1.4496.27611-.3451.48319-.2071 1.10443.2761 1.44956 3.5204 2.3469 3.0372 7.93802 2.9682 8.00712v.4141c-6.0053-2.623-12.97702.2071-15.60003 6.2124-.55221 1.3805-.89735 2.8991-.89735 4.4867 0 6.2124 6.41948 18.6372 14.90978 18.6372.6212 0 1.3115-.138 1.8637-.3451.5522-.2071 1.1044-.2071 1.6566 0 .6213.2761 1.2425.3451 1.8637.3451 7.8691 0 14.9098-12.6318 14.9098-18.6372-.069-6.4885-5.3841-11.7345-11.8726-11.7345Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.2106 6.46802c1.5876-.82832 4.1416-.20708 5.5911.41416-.5522 1.51858-1.5186 2.76106-2.8991 3.65842-1.5876.8283-4.1416.2071-5.5912-.4142.4832-1.51856 1.5186-2.83006 2.8992-3.65838Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.6923 41.9476c-.3451 0-.7593-.069-1.1044-.207-1.0354-.4142-2.2089-.4142-3.2443 0-.3451.138-.6902.207-1.1044.207-6.9027 0-12.83894-11.1132-12.83894-16.5663.06903-5.3841 4.41774-9.6638 9.80174-9.6638 1.7947 0 3.5894.4832 5.177 1.4496.3452.2071.7593.2071 1.1045 0 1.5876-.9664 3.3823-1.4496 5.1769-1.4496 5.3841 0 9.7328 4.2797 9.8018 9.6638.069 5.7982-6.6956 16.5663-12.7699 16.5663Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.633 26.5946c-.4331.1576-.7649.5383-.9225 1.0584-.1575.52-.1279 1.1368.0824 1.7145.4877 1.3399 2.1734 2.0463 2.366 2.1181.088.0343.1774.0371.2572.008.0798-.029.1465-.0887.1919-.1715.1013-.1788.9386-1.8034.4509-3.1433-.2103-.5778-.584-1.0693-1.0389-1.3664-.455-.2971-.9539-.3754-1.387-.2178Zm8.7344-.0002c-.4331-.1577-.932-.0793-1.387.2178-.4549.2971-.8287.7886-1.039 1.3664-.4876 1.3398.3496 2.9645.451 3.1433.0454.0828.1121.1424.1919.1715.0798.029.1692.0262.2572-.0081.1926-.0718 1.8783-.7782 2.3659-2.118.2103-.5778.24-1.1945.0824-1.7146-.1575-.52-.4893-.9007-.9224-1.0583Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Lunch.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Lunch"
};
validateTidalLicense();
export {
  Lunch
};
//# sourceMappingURL=Lunch.js.map
